import { useEffect, useRef, type ReactNode } from 'react'

interface StaffDialogProps {
  titleId: string
  busy?: boolean
  onClose: () => void
  children: (close: () => void) => ReactNode
}

/** Native modal dialog shared by the staff screens; Escape and the backdrop close it unless a request is running. */
export function StaffDialog({ titleId, busy = false, onClose, children }: StaffDialogProps) {
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    dialogRef.current?.showModal()
  }, [])

  const close = () => dialogRef.current?.close()

  return (
    <dialog
      ref={dialogRef}
      onClose={onClose}
      onCancel={(event) => busy && event.preventDefault()}
      aria-labelledby={titleId}
      className="m-auto w-[min(480px,calc(100vw-32px))] rounded-panel border border-line bg-surface p-0 text-ink shadow-panel backdrop:bg-[rgb(27_27_24/0.35)]"
    >
      {children(close)}
    </dialog>
  )
}
